import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGallery from "./components/CategoryGallery";
import ProductCategories from "./components/ProductCategories";
import SeoValueSection from "./components/SeoValueSection";
import CTASection from "./components/CTASection";
import ArticlePreview from "./components/ArticlePreview";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGallery />
        <ProductCategories />
        <SeoValueSection />
        <CTASection />
        <ArticlePreview />
        <FAQSection />
      </main>
      <Footer />

      {/* WebPage + Organization structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": `${import.meta.env.VITE_SITE_URL || "https://pandabuy.casa"}/#website`,
            name: "Pandabuy Spreadsheet — Ultimate Curated Product Directory Hub",
            url: import.meta.env.VITE_SITE_URL || "https://pandabuy.casa/",
            publisher: {
              "@type": "Organization",
              "@id": `${import.meta.env.VITE_SITE_URL || "https://pandabuy.casa"}/#organization`,
              name: "pandabuy.casa",
              url: import.meta.env.VITE_SITE_URL || "https://pandabuy.casa/",
              logo: {
                "@type": "ImageObject",
                url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg",
              },
            },
          }),
        }}
      />
    </>
  );
}